import { render } from "./Header.vue?vue&type=template&id=146bf85c&scoped=true"
import script from "./Header.ts?vue&type=script&lang=js"
export * from "./Header.ts?vue&type=script&lang=js"

import "./Header.vue?vue&type=style&index=0&id=146bf85c&scoped=true&lang=css"

import exportComponent from "/home/gitlab-runner/builds/snj4qLhS/0/titletool/titletool-nextgen-server/titletool-frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-146bf85c"]])

export default __exports__